import AlertModal from "./AlertModal";

export default AlertModal;

export * from "./AlertModal";
